import { render, staticRenderFns } from "./SubGoodsList.vue?vue&type=template&id=2db259b9&scoped=true&"
import script from "./SubGoodsList.vue?vue&type=script&lang=js&"
export * from "./SubGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db259b9",
  null
  
)

export default component.exports